import { apiClient, msLoginApiClient } from "../../../config/netConfig";

/**
 * 获取角色权限关系
 * @param roleId 角色ID
 */
export const getRolePermissions = async (roleId: string) => {
  const response = await msLoginApiClient.get(`/role/${roleId}/permissions`);
  return { data: response.data };
};

/**
 * 为角色分配权限
 * @param roleId 角色ID
 * @param permissionIds 权限ID列表
 */
export const assignPermissionsToRole = async (roleId: string, permissionIds: string[]) => {
  console.log("=== rolePermissionService.assignPermissionsToRole ===");
  console.log("请求参数:", { roleId, permissionIds });

  try {
    const response = await msLoginApiClient.post("/role/assign-permissions", {
      roleId,
      permissionIds,
    });
    console.log("API响应成功:", response.data);
    return { data: response.data };
  } catch (error) {
    console.error("API调用失败:", error);
    throw error;
  }
};

/**
 * 获取用户权限
 * @param userId 用户ID
 */
export const getUserPermissions = async (userId: string) => {
  const response = await apiClient.get(`/user/${userId}/permissions`);
  return { data: response.data };
};

/**
 * 检查用户是否有特定权限
 * @param userId 用户ID
 * @param permission 权限名称
 */
export const checkUserPermission = async (userId: string, permission: string) => {
  const response = await apiClient.post(`/user/${userId}/permissions/check`, {
    permission,
  });
  return { data: response.data };
};
